import { apiProxyRequest } from "Api/apiProxyRequest";

import type { DiscountsResponse } from "../types";

export const getDiscountsRequest = (billingProfileId: string) => {
  return apiProxyRequest<DiscountsResponse>(
    `/billing/profiles/${billingProfileId}/discounts`
  );
};
